import React from "react"
import { EstrategiasFornecedorContextProvider } from "./context/EstrategiasFornecedorContextProvider"
import { EstrategiasFornecedor } from "./EstrategiasFornecedor"

export function Index() {
    return (
        <EstrategiasFornecedorContextProvider>
            <EstrategiasFornecedor />
        </EstrategiasFornecedorContextProvider>
    )
}
